package com.example.mystybag.login.model

import com.example.mystybag.biometricUtils.helpers.BiometricAuthenticationType

data class StaffBiometricUIState(
    val biometricType: BiometricAuthenticationType = BiometricAuthenticationType.NONE,
    val isLoading: Boolean = false,
    /** True when the "Enable biometric" full-screen UI should be shown (first-time setup). */
    val showEnableScreen: Boolean = false
)
